import { InputAdornment, TextField } from '@mui/material';
import Decimal from 'decimal.js';
import { getFieldControlSx } from '../fieldStyles';
import type { FieldRendererProps } from '../types';

function getValidPercentageValue(val: string | undefined | null): string {
  if (!val || val.trim() === '') return '0';
  const numVal = Number(val);
  return Number.isNaN(numVal) ? '0' : val;
}

export function PercentageField({
  field,
  className,
  sx,
  hasWhiteFields = false,
  isDisabled,
  isReadOnly,
  onChange,
}: FieldRendererProps) {
  const percentageFieldValue = getValidPercentageValue(field.value);

  return (
    <TextField
      variant="outlined"
      margin="dense"
      fullWidth
      sx={getFieldControlSx(hasWhiteFields, sx)}
      id={field.id.toString()}
      slotProps={{
        htmlInput: { readOnly: isReadOnly },
        input: {
          type: 'number',
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
        },
      }}
      disabled={isDisabled}
      type={field.type}
      label={field.label}
      required={field.required}
      defaultValue={new Decimal(percentageFieldValue).mul(100).toFixed(2)}
      onChange={(event) => {
        const inputValue = event.target.value.trim();
        if (inputValue === '' || inputValue === '-' || !inputValue || Number.isNaN(Number(inputValue))) {
          onChange('0');
          return;
        }
        const value = new Decimal(inputValue).div(100).toNumber();
        if (!Number.isNaN(value)) {
          onChange(value.toString());
        }
      }}
    />
  );
}
